module.exports = __webpack_public_path__ + "static/img/4016_phase_function_Paper_PointsHejduk_Prediction.c64ae94.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4016_phase_function_Paper_PointsHejduk_Prediction.png
// module id = 7SFS
// module chunks = 0